import {DateTimeManagerParse} from "../Reusable/TimeDateManager";

export const Columns = [
    // {
    //     Header:'Id',
    //     accessor:'id'
    // },

    {
        Header:'Competition Name',
        accessor:'name'
    },
    {
        Header:'Course Name',
        accessor:'golfcourse'
    },
    {
        Header:'Start Date',
        // accessor:'start_date',
        Cell: ({row}) => {
            const {id,start_date} = row.original

            return (
                DateTimeManagerParse(start_date)

            );

        },

    },
    {
        Header:'End Date',
        // accessor:'end_date'
        Cell: ({row}) => {
            const {id,end_date} = row.original

            return (
                DateTimeManagerParse(end_date)

            );

        },
    },

    // {
    //     Header:'Edit',
    //     // accessor:'last_name'
    //     id:"edit"
    //
    // },

    {
        Header:'Delete',
        id:"delete"

    },

]
